import React from "react";
import APILink from "./ApiLink";
import "./Component.css";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import ApiLink from "./ApiLink";
import "./Panel.css";


import logo from  "../components/Myntra_Footer.png";
import { ChevronDown, Youtube, Instagram, Twitter, Linkedin, Facebook} from 'react-bootstrap-icons';



const MenuAccordionComponent = (props) => {


    var cards = [];
    var infocards = [];

    if(props.internal === true){
        for (const [key, value] of props.teamMap.entries()){
            cards.push(
                <Card key={key}>
                    <Card.Header className="card-header-cust"> 
                        <Accordion.Toggle eventKey={key} as={Card.Header} variant="link" className="card-header-cust">           
                        <div>
                            <h5 style={{cursor: "pointer", fontSize: "14px", marginTop: "0.25rem"}}><b>{props.teamNameMap.get(key)}</b></h5>
                        </div>
                        <div className="arrow-align">
                            <ChevronDown />
                        </div>
                        </Accordion.Toggle>
    
                    </Card.Header>
    
                    <Accordion.Collapse eventKey={key}>
                            <Card.Body style={{textAlign: "left", leftPadding: "2px"}}>
                                {value}
                            </Card.Body>
                        </Accordion.Collapse>
                </Card>
            )
        }
    }

    else{
        for (const [key, value] of props.teamMap.entries()){
            cards.push(
                <Card key={key}>
                    <Card.Header className="card-header-cust"> 
                        <Card.Body className="card-body">
                                {value}
                            </Card.Body>
                    </Card.Header>
                </Card>
            )
        }
    }

    return (
        <div>
        <Accordion defaultActiveKey="0">
            {cards}
        </Accordion>
        <br></br>
        </div>
    );
}

export default MenuAccordionComponent;